import { INTERP_COMMON_RULE_PACK_0_94_0 } from './formalRules.js';
import { INTERP_COMMON_TEMPLATE_PACK_0_67_0 } from './formalTemplates.js';
import { assertRulePackIntegrity } from './rulePackValidation.js';

/**
 * Single source of truth for the production natal interpretation pack pair.
 * UI/workflows should consume this selector rather than pinning historical pack constants.
 */
export const PRODUCTION_NATAL_INTERPRETATION = Object.freeze({
  rulePack: INTERP_COMMON_RULE_PACK_0_94_0,
  templatePack: INTERP_COMMON_TEMPLATE_PACK_0_67_0,
});

export function productionNatalInterpretationPacks() {
  assertRulePackIntegrity(PRODUCTION_NATAL_INTERPRETATION.rulePack, PRODUCTION_NATAL_INTERPRETATION.templatePack);
  return PRODUCTION_NATAL_INTERPRETATION;
}
